import { combineEpics } from 'redux-observable';
import { sharedContactsEpic } from './contacts';
import { sharedHighlightsEpic } from './highlights';
import { sharedMomentsEpic } from './moments';
import { sharedNotesEpic } from './notes';
import { sharedSourcesEpic } from './sources';
import { sharedGroupsEpic } from './groups';

export const sharedDataEpics = combineEpics(
  sharedContactsEpic,
  sharedGroupsEpic,
  sharedHighlightsEpic,
  sharedMomentsEpic,
  sharedNotesEpic,
  sharedSourcesEpic,
);
